import {PointModel} from '../../model'
import {aditionalValues} from '../../../../util/utilitario'
export const initValues: PointModel = {
  id: '',
  companiaId: '',
  clienteId: '',
  siteId: '',
  campamentoId: '',
  nombre: '',
  proveedorId: '',
  capacidadInstalada: '',
  cantidadMaquinas: 0,
  tipoAdministracion: '',
  estado: '',
  principal: false,
  ...aditionalValues,
}
